import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export const Collapsible = ({ title, defaultOpen = false, children, testId }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="border border-neutral-200 rounded-xl overflow-hidden" data-testid={testId}>
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between p-4 text-left hover:bg-neutral-50 transition-colors"
        data-testid={testId ? `${testId}-toggle` : undefined}
      >
        <span className="text-[10px] font-bold uppercase tracking-wider text-neutral-500">{title}</span>
        <ChevronDown className={`h-4 w-4 text-neutral-400 transition-transform ${open ? 'rotate-180' : ''}`} strokeWidth={1.5} />
      </button>
      {open && (
        <div className="px-4 pb-4 -mt-1">
          {children}
        </div>
      )}
    </div>
  );
};
